import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=46ccbc1f&scoped=true&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=46ccbc1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ccbc1f",
  null
  
)

export default component.exports